import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Prerendered pages (see scripts/prerender.mjs) ship real static markup
// inside #root so crawlers/link-preview bots get correct content and meta
// tags without running JS. Real visitors still get a full client render on
// top of it — this app's animations (Preloader, Framer Motion variants,
// GSAP/Lenis scroll state) depend on client-only state that can't match a
// static snapshot 1:1, so hydrateRoot would just log mismatch warnings for
// no benefit. A plain render replaces the snapshot almost instantly, which
// is strictly better than the previous blank #root visitors saw before any
// JS ran.
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
